import React from 'react'
import WithSidebarAndHeader from 'ui/layouts/WithSidebarAndHeader'
import NavigationPipelines from 'support/pipelines/NavigationPipelines'
import HandleOuterClicks from 'services/HandleOuterClicks'
import PrimaryNavigation from 'widgets/navigation/PrimaryNavigation'
import AutoLogout from 'widgets/auth/AutoLogout'

export default function Admin (props) {
  return (
    <>
      <NavigationPipelines />
      <AutoLogout />
      <HandleOuterClicks>
        <WithSidebarAndHeader sidebar={<PrimaryNavigation />}>
          <div className='flex'>
            {props.children}
          </div>
        </WithSidebarAndHeader>
      </HandleOuterClicks>
    </>
  )
}
